export default __webpack_public_path__ + "static/image5-2ad59425ecac17be1c8a9e725d9366d5.gif";